export default __webpack_public_path__ + "static/media/3rdCard.4d04b489.jpg";